import { FC } from "react";

const HeaderOffsetPaddingWrapper: FC = () => {
  return <div className="-mt-header-height-mobile md:-mt-header-height-desktop pt-header-height-mobile md:pt-header-height-desktop" />;
}

export default HeaderOffsetPaddingWrapper;
